var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stask-attachments",class:_vm.classes},[_c('div',{staticClass:"lbl"},[_vm._v("Arquivos anexos")]),_c('div',[_c('task-attachments',{ref:"attachments",attrs:{"task":_vm.task}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }